
  document.addEventListener("DOMContentLoaded", function() {
    const breadcrumbCollection = document.getElementById("breadcrumb-collection");
    const path = window.location.pathname;
    const referrer = document.referrer;  // The URL of the previous page

    console.log("Referrer URL:", referrer); // Debug log

    // Check if the referrer is a collection page
    const isFromCollection = referrer.includes('/collections/');

    if (!isFromCollection) {
      console.log("Accessed directly or from a non-collection page, clearing collection from localStorage."); // Debug Log
      localStorage.removeItem("lastCollection");
      sessionStorage.removeItem("lastCollection"); // Also clear sessionStorage for safety
    }

    const lastCollection = localStorage.getItem("lastCollection") || sessionStorage.getItem("lastCollection");
    console.log("Last collection in localStorage:", lastCollection); // Debug Log

    if (lastCollection) {
      fetch(`/collections/${lastCollection}.json`)
        .then(response => response.json())
        .then(data => {
          if (data.collection) {
            const collectionTitle = data.collection.title;
            const collectionUrl = `/collections/${lastCollection}`;
            breadcrumbCollection.innerHTML = `<a href="${collectionUrl}">${collectionTitle}</a>&nbsp;/ `;
            console.log("Breadcrumb rendered with collection:", collectionTitle); // Debug Log
          }
        })
        .catch(err => console.error('Error fetching collection data:', err));
    }
  });
